import { useState, useEffect } from "react";
import { Accordion, Row, Col } from "react-bootstrap";
import Status from "../components/Status.jsx";
import RiderAlerts from "../components/RiderAlerts.jsx";
import RoutesList from "../components/route-components/RoutesList.jsx";
import AllRoutesMap from "../components/map-components/AllRoutesMap.jsx";
import { fetchAllRoutes } from "../services/fetchData.js";
import { startStatus, endStatus } from "../services/statusStore.js";


/**
 * App - Main application component using centralized RouteDataContext
 */
export default function AllRoutes() {
  const [routesList, setRoutesList] = useState([]);
  const [activeKey, setActiveKey] = useState("0");

  useEffect(() => {
    let active = true;
    const statusId = startStatus("Loading routes list...");

    fetchAllRoutes()
      .then((routes) => {
        if (!active) return;

        const orderedRoutes = Array.isArray(routes)
          ? routes
            .slice()
            .sort((a, b) =>
              String(a.route_short_name).localeCompare(String(b.route_short_name), undefined, {
                numeric: true,
                sensitivity: "base"
              })
            )
          : [];

        setRoutesList(orderedRoutes);
        endStatus(statusId);
      })
      .catch(() => {
        if (!active) return;
        setRoutesList([]);
        endStatus(statusId);
        startStatus("Failed to load routes list.");
        setTimeout(() => {
          // Remove error after a short delay
          endStatus(statusId + 1); // assumes nextId increments by 1
        }, 4000);
      });
    return () => {
      active = false;
      endStatus(statusId);
    };
  }, []);

  return (
    <Row className="ictapp__all_routes">
      <Col xs={12} className="mb-4">
        <Row className="">
          <Col>
            <Accordion
              activeKey={activeKey}
              onSelect={setActiveKey}
              className="ictapp__map darken"
            >
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  {activeKey === "0" ? (
                    <>
                      <i className="fas fa-chevron-up" aria-hidden="true" /> Close
                      System Map
                    </>
                  ) : (
                    <>
                      <i className="fas fa-chevron-down" aria-hidden="true" /> Open
                      System Map
                    </>
                  )}
                </Accordion.Header>

                <Accordion.Body style={{ padding: 0 }}>


                  <AllRoutesMap routes={routesList} />

                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Col>
        </Row>
      </Col>

      <Col md={6}>
        <h2 className="routes-panel__title mb-3">Select a Bus Route</h2>
        <RoutesList routes={routesList} />
      </Col>

      <Col md={6}>
        <div className="d-flex justify-content-between align-items-baseline mb-3">
          <h2 className="routes-panel__title mb-0">Alerts and Announcements</h2>
          <a
            href="/rider-alerts"
            className="no-underline hover-underline fw-bold"
          >
            View All Alerts{" "}
            <i className="fas fa-long-arrow-alt-right" aria-hidden="true" />
          </a>
        </div>
        <RiderAlerts emptyMessage="None at this time." />
      </Col>
      <Status />
    </Row>
  );
}
